import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeDegatValues } from 'src/api/models';

@Component({
  selector: 'app-degats-type-select',
  templateUrl: './degats-type-select.component.html',
  styleUrls: ['./degats-type-select.component.css']
})
export class DegatsTypeSelectComponent implements OnInit {

  @Input('id') public id: number;
  @Input() public isDisabled: boolean = false;
  @Input() public required: boolean = false;
  @Output() idChange = new EventEmitter<number>();

  @Input('width') width: number;

  @Input() cell: any;

  typeDegats = [];

  constructor(private translateService: TranslateService) {     
    for (var t in TypeDegatValues) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.typeDegats.push({ id: value, name: this.translateService.instant('Entretien.Interventions.TypeDegats.' + TypeDegatValues[t])});
      }
    }    
  }

  ngOnInit(): void {
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }   

}
